export default "__VITE_ASSET__BP9CI8ij__"